import { AutogenModelBrTrackingDocTypeMap, AutogenRowBrTrackingDocTypeMap } from "./autogen/AutogenModelBrTrackingDocTypeMap";

export class ModelBrTrackingDocTypeMap extends AutogenModelBrTrackingDocTypeMap<RowBrTrackingDocTypeMap> {
	constructor() {
		super(RowBrTrackingDocTypeMap);
	}
}

export class RowBrTrackingDocTypeMap extends AutogenRowBrTrackingDocTypeMap {
}